// extracted by mini-css-extract-plugin
export default {"shadowInner":"style_shadowInner__Oo-V8"};